import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexColCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { __ } from 'react-i18n';

export enum Type {
  CLASSIC,
}

interface Props {
  name: string;
  theme: any;
  url: string;
  img: string;
  lastParent: any;
  type: Type;
  closeMenu: () => void;
  categoryName?: string;
}

function CategoryCard({
  name,
  theme,
  url,
  img,
  lastParent,
  type,
  closeMenu,
  categoryName,
}: Props) {
  const getName = (catName: string): string => {
    const maxLength = 50;
    if (catName.length > maxLength) {
      return catName.substring(0, maxLength) + '...';
    }
    return catName.substring(0, maxLength);
  };

  const normalizedCategoryName =
    categoryName && categoryName.trim().toLowerCase();
  const isSpecialCategory =
    normalizedCategoryName === 'výpredaj' ||
    normalizedCategoryName === 'darčeková poukážka';

  return (
    <Wrapper onClick={closeMenu} to={url}>
      {!isSpecialCategory ? (
        <Image alt={`Obrázok kategórie ${name}`} src={img} type={type} />
      ) : (
        <SpecialCategoryIcon type={type}>
          <SvgIcon
            width={40}
            height={40}
            viewBox="0 0 40 40"
            icon={
              normalizedCategoryName === 'výpredaj'
                ? IconType.sale
                : IconType.gift
            }
            fill={normalizedCategoryName === 'výpredaj' ? '#D2A4B0' : '#A5BBA2'}
            alt={
              normalizedCategoryName === 'výpredaj'
                ? __('Výpredaj')
                : __('Darčeková poukážka')
            }
            title={
              normalizedCategoryName === 'výpredaj'
                ? __('Výpredaj')
                : __('Darčeková poukážka')
            }
          />
        </SpecialCategoryIcon>
      )}
      <CategoryNameLink type={type}>
        {lastParent ? `...  / ${lastParent.category_name}  /  ` : ''}
        {getName(name)}
      </CategoryNameLink>
    </Wrapper>
  );
}

const Wrapper = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 0;
  padding: ${rem(8)} ${rem(16)};
  text-decoration: none;

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primaryBackground};
    border-radius: ${rem(4)};
  }

  ${({ theme }) => theme.mediab.m760`
    padding: 0;
  `}
`;

const Image = styled.img<{ type: Type }>`
  width: ${rem(40)};
  height: ${rem(40)};
  margin: ${rem(8)} ${rem(16)};
  min-width: ${rem(40)};

  ${({ type }) =>
    type === Type.CLASSIC &&
    `
      margin: 0;
    `}
`;

const CategoryNameLink = styled.p<{ type: Type }>`
  font-size: ${rem(16)};
  line-height: ${rem(24)};

  ${({ type }) =>
    type === Type.CLASSIC &&
    `
      font-size: ${rem(14)};
      font-weight: 500;
      line-height: ${rem(21)};
    `}

  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  text-decoration: none;
  margin-left: ${rem(16)};
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40ch;
`;

const SpecialCategoryIcon = styled(FlexColCenter)<{
  type: Type;
}>`
  width: ${rem(40)};
  height: ${rem(40)};
  min-width: ${rem(40)};
  border-radius: 50%;
  margin: ${rem(8)} ${rem(16)};

  ${({ type }) =>
    type === Type.CLASSIC &&
    `
      margin: 0;
    `}
`;

const WithTheme: any = withTheme(CategoryCard);
export { WithTheme as CategoryCard };
